import React from 'react';
import {compose} from 'react-recompose';
import {connect} from 'react-redux';
import {onProfilePressed} from './../actions';

const TeamMemberProfile = ({memberProfileInfo, profileIndex, onProfilePressed, activeProfile}) => {
    let activeProfileClass = activeProfile === profileIndex ? 'active' : '';
    return (
        <div className={`col-xs-6 col-sm-4 team-member-profile ${activeProfileClass}`}
             onClick={() => onProfilePressed(profileIndex)}>
            <div className="img">
                <img alt={memberProfileInfo.name} className="img1" src={memberProfileInfo.image}  loading='lazy'/>
                <img alt={memberProfileInfo.name} className="img2" src={memberProfileInfo.image2} loading='lazy'/>
            </div>
            <p>{memberProfileInfo.name}<br/><span className="profile-title">{ memberProfileInfo.title }</span></p>
            <div className="profile-info-block">
                <div className="profile-description">
                    <i className="close fas fa-times"></i>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <img alt={memberProfileInfo.name} src={memberProfileInfo.image3} loading='lazy'/>
                            <h3>{memberProfileInfo.name}</h3>
                            <p className="profile-title"><em>{memberProfileInfo.title}{ memberProfileInfo.title2 }</em></p>
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <div dangerouslySetInnerHTML={{__html: memberProfileInfo.bio}}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


const reduxConnect = connect(state => {
    const {activeProfile} = state.meetOurTeam;

    return {
        activeProfile
    }
}, {onProfilePressed})

const composeHoc = compose(
    reduxConnect
);

export default composeHoc(TeamMemberProfile);
